var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "brutto" } }, [
            _vm._v(_vm._s(_vm.T.haviBruttoBer[_vm.lang]))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "input-group input-group-lg" }, [
            _c("input", {
              staticClass: "form-control",
              attrs: {
                id: "brutto",
                "aria-label": "Bruttó bér",
                type: "number",
                min: "100"
              },
              domProps: { value: _vm.brutto },
              on: { input: _vm.updateBrutto }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "input-group-addon" }, [_vm._v("Ft")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-2" }, [
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("input", {
            staticClass: "form-control",
            staticStyle: { width: "100%" },
            attrs: { type: "range", min: "100", max: "2000000" },
            domProps: { value: _vm.brutto },
            on: { input: _vm.updateBrutto }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-2" }, [
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5 text-center" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary mr-3",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.adjust(-5)
              }
            }
          },
          [_vm._v("-5%")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-secondary mr-3",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.adjust(-1)
              }
            }
          },
          [_vm._v("-1%")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-secondary mr-3",
            attrs: { type: "button" },
            on: { click: _vm.resetAdjustment }
          },
          [_vm._v("🔄")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-secondary mr-3",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.adjust(1)
              }
            }
          },
          [_vm._v("+1%")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-secondary",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.adjust(5)
              }
            }
          },
          [_vm._v("+5%")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" })
    ]),
    _vm._v(" "),
    _vm.adjustment !== 0
      ? _c("div", { staticClass: "row mb-2" }, [
          _c("div", { staticClass: "col" }),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-5 text-center" }, [
            _c(
              "i",
              { staticStyle: { color: "gray", "margin-right": "0.5em" } },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.format(_vm.originalBrutto, false)) +
                    " \n          " +
                    _vm._s(_vm.adjustment > 0 ? "+" : "-") +
                    " \n          " +
                    _vm._s(Math.abs(_vm.adjustment)) +
                    "%\n          (" +
                    _vm._s(_vm.format(_vm.adjustmentAmount, true)) +
                    " Ft)\n        "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col" })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5 text-center" }, [
        _c(
          "div",
          { staticClass: "btn-group btn-group-sm", attrs: { role: "group" } },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.minimalber }
              },
              [_vm._v(_vm._s(_vm.T.minimalber[_vm.lang]))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.berminimum }
              },
              [_vm._v(_vm._s(_vm.T.berminimum[_vm.lang]))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.atlagber }
              },
              [_vm._v(_vm._s(_vm.T.atlagber[_vm.lang]))]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-2" }, [
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "netto" } }, [
            _vm._v(_vm._s(_vm.T.nettoBer[_vm.lang]))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "input-group input-group-lg" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.netto,
                  expression: "netto"
                }
              ],
              staticClass: "form-control",
              attrs: {
                id: "netto",
                "aria-label": "Nettó bér",
                type: "number",
                min: "0",
                value: "300000"
              },
              domProps: { value: _vm.netto },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.netto = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "input-group-addon" }, [_vm._v("Ft")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5" }, [
        _c("div", { staticClass: "form-check" }, [
          _c(
            "label",
            { staticClass: "form-check-label", attrs: { for: "frissHazas" } },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.frissHazas,
                    expression: "frissHazas"
                  }
                ],
                staticClass: "form-check-input",
                attrs: {
                  id: "frissHazas",
                  "aria-label": "Friss házasok kedvezménye",
                  type: "checkbox"
                },
                domProps: {
                  checked: Array.isArray(_vm.frissHazas)
                    ? _vm._i(_vm.frissHazas, null) > -1
                    : _vm.frissHazas
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.frissHazas,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.frissHazas = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.frissHazas = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.frissHazas = $$c
                    }
                  }
                }
              }),
              _vm._v(
                "\n          " +
                  _vm._s(_vm.T.frissHazasokKedvezmenye[_vm.lang]) +
                  "\n        "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5" }, [
        _c("div", { staticClass: "form-check" }, [
          _c(
            "label",
            { staticClass: "form-check-label", attrs: { for: "fiatal" } },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fiatal,
                    expression: "fiatal"
                  }
                ],
                staticClass: "form-check-input",
                attrs: {
                  id: "fiatal",
                  "aria-label": "25 év alattiak szja-mentessége",
                  type: "checkbox"
                },
                domProps: {
                  checked: Array.isArray(_vm.fiatal)
                    ? _vm._i(_vm.fiatal, null) > -1
                    : _vm.fiatal
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.fiatal,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.fiatal = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.fiatal = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.fiatal = $$c
                    }
                  }
                }
              }),
              _vm._v(
                "\n          " +
                  _vm._s(_vm.T.szjaMentesseg[_vm.lang]) +
                  "\n        "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5" }, [
        _c("div", { staticClass: "form-check" }, [
          _c(
            "label",
            {
              staticClass: "form-check-label",
              attrs: { for: "szjaMentesAnya" }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.szjaMentesAnya,
                    expression: "szjaMentesAnya"
                  }
                ],
                staticClass: "form-check-input",
                attrs: {
                  id: "szjaMentesAnya",
                  "aria-label": "SZJA-mentes anya",
                  type: "checkbox"
                },
                domProps: {
                  checked: Array.isArray(_vm.szjaMentesAnya)
                    ? _vm._i(_vm.szjaMentesAnya, null) > -1
                    : _vm.szjaMentesAnya
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.szjaMentesAnya,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.szjaMentesAnya = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.szjaMentesAnya = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.szjaMentesAnya = $$c
                    }
                  }
                }
              }),
              _vm._v(
                "\n          " +
                  _vm._s(_vm.T.szjaMentesAnya[_vm.lang]) +
                  "\n        "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5" }, [
        _c("div", { staticClass: "form-check" }, [
          _c(
            "label",
            { staticClass: "form-check-label", attrs: { for: "fiatalAnya" } },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fiatalAnya,
                    expression: "fiatalAnya"
                  }
                ],
                staticClass: "form-check-input",
                attrs: {
                  id: "fiatalAnya",
                  "aria-label": "30 év alatti anya",
                  type: "checkbox"
                },
                domProps: {
                  checked: Array.isArray(_vm.fiatalAnya)
                    ? _vm._i(_vm.fiatalAnya, null) > -1
                    : _vm.fiatalAnya
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.fiatalAnya,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.fiatalAnya = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.fiatalAnya = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.fiatalAnya = $$c
                    }
                  }
                }
              }),
              _vm._v(
                "\n          " +
                  _vm._s(_vm.T.fiatalAnya[_vm.lang]) +
                  "\n        "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5" }, [
        _c("div", { staticClass: "form-check" }, [
          _c(
            "label",
            { staticClass: "form-check-label", attrs: { for: "szemelyi" } },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.szemelyi,
                    expression: "szemelyi"
                  }
                ],
                staticClass: "form-check-input",
                attrs: {
                  id: "szemelyi",
                  "aria-label": "Személyi kedvezmény",
                  type: "checkbox"
                },
                domProps: {
                  checked: Array.isArray(_vm.szemelyi)
                    ? _vm._i(_vm.szemelyi, null) > -1
                    : _vm.szemelyi
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.szemelyi,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.szemelyi = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.szemelyi = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.szemelyi = $$c
                    }
                  }
                }
              }),
              _vm._v(
                "\n          " +
                  _vm._s(_vm.T.szemelyiKedvezmeny[_vm.lang]) +
                  "\n        "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-1" }, [
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "kedveltartott" } }, [
            _vm._v(_vm._s(_vm.T.kedvezmenyezettEltartott[_vm.lang]))
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.kedveltartott,
                  expression: "kedveltartott"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "kedveltartott" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.kedveltartott = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { attrs: { value: "0" } }, [_vm._v("0")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "1" } }, [_vm._v("1")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "2" } }, [_vm._v("2")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "3" } }, [_vm._v("3")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "4" } }, [_vm._v("4")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "5" } }, [_vm._v("5")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "6" } }, [_vm._v("6")])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "nemkedveltartott" } }, [
            _vm._v(_vm._s(_vm.T.nemKedvezmenyezettEltartott[_vm.lang]))
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.nemkedveltartott,
                  expression: "nemkedveltartott"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "nemkedveltartott" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.nemkedveltartott = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { attrs: { value: "0" } }, [_vm._v("0")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "1" } }, [_vm._v("1")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "2" } }, [_vm._v("2")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "3" } }, [_vm._v(">2")])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5" }, [
        _c(
          "a",
          {
            attrs: { href: "#", "aria-controls": "privacyInfo" },
            on: { click: _vm.showSickleave }
          },
          [_vm._v(_vm._s(_vm.T.betegszabadsag[_vm.lang]))]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-2" }, [
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-8 text-center" }, [
        _c(
          "div",
          {
            staticClass: "alert alert-info",
            class: {
              "collapse.show": _vm.sickleaveShow,
              collapse: !_vm.sickleaveShow
            },
            attrs: { id: "sickleaveInfo", role: "alert" }
          },
          [
            _c("p", { staticClass: "text-justify" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.T.betegszabadsag[_vm.lang]) + ":")
              ]),
              _vm._v(
                "\n          " +
                  _vm._s(_vm.T.betegszabadsagInfo[_vm.lang]) +
                  "\n        "
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row", class: { "d-none": !_vm.sickleaveShow } }, [
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-5" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "sickleaveMonth" } }, [
            _vm._v(_vm._s(_vm.T.honap[_vm.lang]))
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.sickleaveMonth,
                  expression: "sickleaveMonth"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "sickleaveMonth" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.sickleaveMonth = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            _vm._l(_vm.T.months[_vm.lang], function(month, index) {
              return _c(
                "option",
                { key: index, domProps: { value: index + 1 } },
                [_vm._v(_vm._s(month))]
              )
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row mb-2", class: { "d-none": !_vm.sickleaveShow } },
      [
        _c("div", { staticClass: "col" }),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "sickleaveCount" } }, [
              _vm._v(_vm._s(_vm.T.betegszabadsag[_vm.lang]))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.sickleaveCount,
                  expression: "sickleaveCount"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                id: "sickleaveCount",
                min: "0",
                max: "15"
              },
              domProps: { value: _vm.sickleaveCount },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.sickleaveCount = $event.target.value
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col" })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0027f016", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0027f016","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/Calculator.vue
// module id = 22
// module chunks = 0